import { makeAuthenticatedRequestWithHandling } from "./api";

export const getListOfAllEventsCalendar = async ({ classroomId }) => {
  try {
    const URL = `/calendar/data/${classroomId}`;
    const response = await makeAuthenticatedRequestWithHandling(URL);
    return await response?.json();
  } catch (error) {
    console.error("Error during creating assessments:", error);
    return { ok: false, error: error };
  }
};

export function calculateEndDateTime(startDateAndTime, durationInMinutes) {
  // Convert the ISO string to a Date object
  const startDate = new Date(startDateAndTime);

  // Add the duration (minutes converted to milliseconds)
  startDate.setMinutes(startDate.getMinutes() + durationInMinutes);

  // Convert back to ISO string format
  return startDate.toISOString();
}

export function calculateDuration(startTime, endTime) {
  // Parse times into Date objects (assuming same day)
  const [startHour, startMinute] = startTime.split(":").map(Number);
  const [endHour, endMinute] = endTime.split(":").map(Number);

  // Create Date objects (with dummy date, as only time matters)
  const startDate = new Date(0, 0, 0, startHour, startMinute);
  const endDate = new Date(0, 0, 0, endHour, endMinute);

  // Calculate difference in milliseconds and convert to minutes
  const durationInMinutes = (endDate - startDate) / (1000 * 60);

  // Handle cases where end time is past midnight (e.g., 23:30 to 01:15)
  return durationInMinutes >= 0 ? durationInMinutes : 1440 + durationInMinutes;
}
